/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_TitleInputs */



/**
* | output |
* | --- |
* | "Integration Settings" |
*
* @param {Options_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_title = /** @type {((inputs?: Options_Integrations_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'intégration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Integrationseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di integrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки интеграции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de integración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("集成设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("統合設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकीकरण सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de integração")
	return /** @type {LocalizedString} */ ("Integration Settings")
});